import client from "../modules/client";

export const getList = () => {
  return client(`/api/v0/favourites`).then(({ data }) => data);
};

export const likeTrainers = (ids) => {
  return client(`/api/v0/favourites/trainers`, {body: {trainers: ids}}).then(({ data }) => data);
};

export const unlikeTrainer = (id) => {
  return client(`/api/v0/favourites/trainers/${id}`, {method: 'DELETE'}).then(({ data }) => data);
};

export const likeCategories = (ids) => {
  return client(`/api/v0/favourites/categories`, {body: {categories: ids}}).then(({ data }) => data);
};

export const unlikeCategory = (id) => {
  return client(`/api/v0/favourites/categories/${id}`, {method: 'DELETE'}).then(({ data }) => data);
};

export function useFavouritesService () {
  return {
    getList,
    likeTrainers,
    unlikeTrainer,
    likeCategories,
    unlikeCategory,
  };
}
